module.exports = __webpack_public_path__ + "static/assets/00a1d3dd1a9ea44580b19e64c0fb2cc6.png";